(function () {
  'use strict';

  angular
    .module('BuscaRegiaoModule', []);
}());
